module.exports = __webpack_public_path__ + "img/share.f7a5734d.svg";